import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TagManager from 'react-gtm-module';

import {
  Wrapper,
  Container,
  Title,
  ItemsWrapper,
  Items,
  Item,
} from '@/components/Article/TableOfContentsSection.style';
import Placeholder from '@/components/Placeholder';
import quickLink from '@/services/quickLink';
import { generateKey } from '@/utils';

// 目次の最終行かどうか判定するのに使用する
const coefficientAdditional = 1;

/**
 * 目次
 */
class TableOfContentsSection extends PureComponent {
  constructor(props) {
    super(props);

    // 目次を選択した時に呼ばれる関数
    this.handlerClickIndex = this.handlerClickIndex.bind(this);
  }

  /**
   * 目次を選択した時に呼ばれる
   */
  handlerClickIndex = text => {
    const key = 'id_text';

    const tagManagerArgs = {
      gtmId: 'GTM-P5G2HJ3',
      dataLayer: {
        [key]: text,
        event: 'indexClick',
      },
    };

    TagManager.initialize(tagManagerArgs);
  };

  render() {
    const { title, quickLinks, linkHandle } = this.props;

    return (
      <Wrapper>
        <Container>
          <Title>{title}</Title>
          <ItemsWrapper>
            {!(quickLinks || (quickLinks.length > 0 && _.find(quickLinks, item => _.get(item, 'quickLinkLabel')))) ? (
              <Placeholder width="100%" height="100px" />
            ) : (
              <Items>
                {quickLinks.map(({ label, id }, index) => (
                  <Item
                    key={generateKey('quick-link', index)}
                    onClick={() => {
                      this.handlerClickIndex(label);
                      quickLink({ linkHandle, id });
                    }}
                    isLast={quickLinks.length === index + coefficientAdditional}
                  >
                    {label}
                  </Item>
                ))}
              </Items>
            )}
          </ItemsWrapper>
        </Container>
      </Wrapper>
    );
  }
}

TableOfContentsSection.defaultProps = {
  title: null,
  quickLinks: null,
  linkHandle: null,
};

TableOfContentsSection.propTypes = {
  title: PropTypes.string,
  quickLinks: PropTypes.arrayOf(PropTypes.shape()),
  linkHandle: PropTypes.func,
};

export default TableOfContentsSection;



// WEBPACK FOOTER //
// ./src/components/Article/TableOfContentsSection.js